import request from '@/utils/request'

export function getList (filters, pagination) {
  return request({
    url: '/log',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDashboardData (protocol_id, site_id) {
  const params = []
  if (protocol_id) {
    params.push(`protocol_id=${protocol_id}`)
  }
  if (site_id) {
    params.push(`site_id=${site_id}`)
  }
  return request({
    url: `/dashboard_data?${params.join('&')}`,
    method: 'get'
  })
}
